import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const AdvertisingStrategy = () => {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

    return (
        <div className="w-full mx-auto p-6 lg:px-12 lg:py-16 text-zinc-800 dark:text-zinc-200 text-sm" ref={ref}>
            <div className="grid lg:grid-cols-2 gap-12 items-center justify-between">

                <motion.div 
                    className="lg:w-11/12 space-y-4 lg:space-y-6"
                    initial={{ opacity: 0, x: -50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="flex flex-row text-zinc-800 dark:text-zinc-200 font-light items-center justify-between">
                        <div className="flex justify-start space-x-3 items-center">
                            <span className="text-purple-600 dark:text-purple-400 font-mono text-xl font-bold">02</span>
                            <span className="text-3xl lg:text-4xl font-bold text-zinc-900 dark:text-white">Custom AI Integrations</span>
                        </div>
                    </div>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Integrating pre-trained models into existing business systems requires absolute security and high throughput. We build custom API layers, fine-tune open weights models (Llama, Mistral), and set up scalable serving endpoints.
                    </p>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Through secure Retrieval-Augmented Generation (RAG) pipelines, we connect LLMs directly to your internal corporate knowledge bases safely, ensuring hallucination-free, context-aware operations.
                    </p>
                </motion.div>

                <motion.div 
                    className="mx-auto lg:w-11/12 w-full"
                    initial={{ opacity: 0, x: 50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="p-8 rounded-2xl border border-slate-200 dark:border-purple-500/20 bg-white dark:bg-[#202222] shadow-[0_4px_20px_rgba(0,0,0,0.03)] dark:shadow-[0_0_35px_rgba(168,85,247,0.08)] hover-glow transition-all duration-300">
                        <h4 className="text-sm font-semibold mb-6 text-zinc-900 dark:text-white flex items-center space-x-2">
                            <span className="w-2 h-2 rounded-full bg-purple-500 animate-ping"></span>
                            <span>Secure RAG Processing Architecture</span>
                        </h4>
                        <div className="space-y-3 font-mono text-xs">
                            <div className="p-3 bg-purple-500/5 dark:bg-purple-950/10 rounded-lg border border-purple-500/10 flex items-center justify-between">
                                <span className="text-purple-700 dark:text-purple-300 font-medium">1. User Request Query</span>
                                <span className="text-zinc-400 dark:text-slate-500">[HTTPS / AES-256]</span>
                            </div>
                            <div className="text-center text-purple-500">↓</div>
                            <div className="p-3 bg-purple-500/5 dark:bg-purple-950/10 rounded-lg border border-purple-500/10 flex items-center justify-between">
                                <span className="text-purple-700 dark:text-purple-300 font-medium">2. Vector Search (Pinecone/pgvector)</span>
                                <span className="text-green-600 dark:text-green-400 font-semibold">&lt; 0.1ms Latency</span>
                            </div>
                            <div className="text-center text-purple-500">↓</div>
                            <div className="p-3 bg-purple-500/5 dark:bg-purple-950/10 rounded-lg border border-purple-500/10 flex items-center justify-between">
                                <span className="text-purple-700 dark:text-purple-300 font-medium">3. Contextual LLM Processing</span>
                                <span className="text-purple-600 dark:text-purple-400 animate-pulse font-medium">Running fine-tuned Llama-3</span>
                            </div>
                        </div>
                    </div>
                </motion.div>

            </div>
        </div>
    )
}

export default AdvertisingStrategy